/* eslint-disable react/prop-types */
import React from 'react';

import { Text, Flex } from 'roo-ui/components';

export const UnavailableMessage = ({ children }) => (
  <Flex alignItems="center" mt={[1, 0]} mb={[2, 0]}>
    <Text fontWeight="bold" fontSize="base" color="orange" mr={4}>
      {children}
    </Text>
  </Flex>
);
